
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const PageConst= {
  ACTION: {},
  ROW_DETAIL_TEMPLATE: {
    row1: { disabled: true, showComment: false, showBtn: false, list: [], comment: '' },
    row2: { disabled: true, showComment: false, showBtn: false, list: [], comment: '' },
    row3: { disabled: true, showComment: false, showBtn: false, list: [], comment: '' },
    row4: { disabled: true, showComment: false, showBtn: false, list: [], comment: '' },
    row5: { disabled: true, showComment: false, showBtn: false, list: [], comment: '' },
    row6: { disabled: true, showComment: false, showBtn: false, list: [], comment: '' },
    row7: { disabled: true, showComment: false, showBtn: false, list: [], comment: '' },
    row8: { disabled: true, showComment: false, showBtn: false, list: [], comment: '' },
    row9: { disabled: true, showComment: false, showBtn: false, list: [], comment: '' },
    row10: { disabled: true, showComment: false, showBtn: false, list: [], comment: '' },
    row11: { disabled: true, showComment: false, showBtn: false, list: [], comment: '' },
    row12: { disabled: true, showComment: false, showBtn: false, list: [], comment: '' },
    row13: { disabled: true, showComment: false, showBtn: false, list: [], comment: '' },
    row14: { disabled: true, showComment: false, showBtn: false, list: [], comment: '' },
    row15: { disabled: true, showComment: false, showBtn: false, list: [], comment: '' },
    row16: { disabled: true, showComment: false, showBtn: false, list: [], comment: '' },
  }
}

const module = {
  state: {
    PageConst,

    pageMode: '',

    currentFormData: {},
    previousFormData: {},
    previousReportNoList: [],
    rowDetail: {},
    nextScheduleList: [],

    dropdownList: {
      teachingMaterial: [],
      submitHomework: [],
      teachingProgress: [],
      classAttitude: [],
      confirmationResult: [],
    },

    pastReportList: [],
  },

  getters: {
    getIsAnyRowEditingOnAmendMode: (state) => {
      return Object.values(state.rowDetail).some(row => !row.disabled)
    },
    getReportStatusInfo: (state) => {
      return window.vue.$store.getters['C50101/reportStatusButton'](state.currentFormData.report_status)
    },
    getIsHandoverAdvisorTextVisible: (state) => {
      return ['',null,undefined].includes(state.currentFormData.handover_advisor) === false
    },
  },

  mutations: {
    INIT_STATE (state) {
      state.pageMode = ''
      state.currentFormData = {}
      state.previousFormData = {}
      state.previousReportNoList = []
      state.rowDetail = JSON.parse(JSON.stringify(PageConst.ROW_DETAIL_TEMPLATE)) // deep copy
    },
    SET_FORMDATA (state, payload) { state.formData = payload },
    SET_ROW_DETAIL (state, payload) { state.rowDetail = payload },
    SET_ALL_ROW_ENABLED (state, {disabled=false}) {
      for (const key in state.rowDetail) {
        state.rowDetail[key].disabled = disabled
      }
    },
  },

  actions: {
    async init ({ state, commit }, { scheduleNo }) {
      commit('INIT_STATE')
      return await $this.$api.postData({
        data: [
          { api: 'T3110LessonReportService.getDropdownList', input: {} },
          { api: 'T3110LessonReportService.getEdit', input: { schedule_no: scheduleNo } },
          { api: 'T3110LessonReportService.getPreviousReportNoList', input: { schedule_no: scheduleNo } },
          { api: 'T3110LessonReportService.getComment', input: { schedule_no: scheduleNo } },
          { api: 'T3110LessonReportService.getAmendComment', input: { schedule_no: scheduleNo } },
          { api: 'T3110LessonReportService.getNextScheduleList', input: { schedule_no: scheduleNo } },
          { api: 'T3114PastLessonReportService.C50102_getPastReport', input: { schedule_no: scheduleNo } },
        ]
      }).then((data) => {
        // Set dropdown list
        const res = data[0].output
        state.dropdownList.teachingMaterial = res.filter(item => item.names_no === 101).map(item => item.names1_value);
        state.dropdownList.submitHomework = res.filter(item => item.names_no === 102).map(item => item.names1_value);
        state.dropdownList.teachingProgress = res.filter(item => item.names_no === 103);
        state.dropdownList.classAttitude = res.filter(item => item.names_no === 104);
        state.dropdownList.confirmationResult = res.filter(item => item.names_no === 105).map(item => item.names1_value);

        // Set current form data
        state.currentFormData = data[1].output[0] || {}

        // Set previous report no list
        state.previousReportNoList = data[2].output

        // Set page mode, row detail and comment
        const pageMode = window.vue.$router.currentRoute.value.query.viewMode ? 'view' : window.vue.$store.getters['C50101/reportStatusButton'](data[1].output[0].report_status).C50102Mode
        state.pageMode = pageMode
        if (['add','afterReview'].includes(pageMode)) {
          commit('SET_ALL_ROW_ENABLED',{disabled:false})
        } else if (pageMode === 'review') {
          const res = data[3].output
          for (const key in res) {
            state.rowDetail[key].list = res[key]
            state.rowDetail[key].showBtn = true
          }
        } else if (pageMode === 'amend') {
          const res = data[4].output
          for (const key in res) {
            if (res[key].length !== 0) {
              state.rowDetail[key].list = res[key]
              state.rowDetail[key].showBtn = true
              state.rowDetail[key].disabled = false
            }
          }
        }

        // Set next schedule list
        state.nextScheduleList = data[5].output

        // Set past report list
        state.pastReportList = data[6].output || []
      })
    },
    async doEdit ({ state }, payload) {
      return await $this.$api.postData({
        data: [
          { api: 'T3110LessonReportService.doEdit', input: state.currentFormData },
        ]
      }).then((data) => data[0].output)
    },
    async doEditRow ({ state }, payload) {
      return await $this.$api.postData({
        data: [
          { api: 'T3110LessonReportService.doEditRow', input: payload },
        ]
      })
    },
    async doEditHandover ({ state }) {
      return await $this.$api.postData({
        data: [
          { api: 'T3110LessonReportService.doEditHandover', input: state.currentFormData },
        ]
      })
    },
    async C50102_doResolveConflict ({ state }, payload) {
      return await $this.$api.postData({
        data: [
          { api: 'T3113HandoverLessonService.C50102_doResolveConflict', input: payload },
        ]
      })
    },
    async doComment ({ state }, { scheduleNo, detailNo, comment }) {
      return await $this.$api.postData({
        data: [
          { api: 'T3110LessonReportService.doComment', input: {
            schedule_no: scheduleNo,
            detail_no: detailNo,
            comment,
            t3110_lock_version: state.currentFormData.t3110_lock_version
          }},
        ]
      }).then((data) => {
        state.rowDetail[`row${detailNo}`].list.push(data[0].output)
        state.rowDetail[`row${detailNo}`].comment = ''
        state.rowDetail[`row${detailNo}`].showComment = false
        state.currentFormData.t3110_lock_version = state.currentFormData.t3110_lock_version + 1
      })
    },
    async getPreviousReport ({ state }, { scheduleNo }) {
      return await $this.$api.postData({
        data: [
          { api: 'T3110LessonReportService.getEdit', input: { schedule_no: scheduleNo } },
        ]
      }).then((data) => {
        state.previousFormData = data[0].output[0] || {}
      })
    },
    async C50102_getPastReport ({ state }, { scheduleNo }) {
      return await $this.$api.postData({
        data: [
          { api: 'T3114PastLessonReportService.C50102_getPastReport', input: { schedule_no: scheduleNo } },
        ]
      }).then((data) => {
        state.pastReportList = data[0].output || []
      })
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
